import React, { useState, useContext } from 'react'

import Button, { NoBackgroundButton } from '../../../../../components/Button'

import contractContext from '../../../../../store/contexts/contractContext'
import CONTRACT_ACTIONS from '../../../../../store/actions/contractActions'

import SelectBox from 'components/SelectBox'

import ErrorComponent from 'components/ErrorComponent'
import { getDepositMonthsOptions } from 'helpers/warranty'
import { useCommonStyles } from 'styles/globalStyles'

const NumberOfDeposits = () => {
  const commonClasses = useCommonStyles()
  const {
    proposition: { propositionDispatch },
    handleStepChange,
    contract: { values },
  } = useContext(contractContext)
  const { rent } = values

  const [bondsNumber, setBondsNumber] = useState<number | null>(null)
  const [errors, setErrors] = useState<string[]>([])

  const handleSetInsurance = () => {
    if (bondsNumber === null) {
      setErrors(['Por favor selecione uma opção de caução.'])
      return
    }

    setErrors([])

    propositionDispatch({
      type: CONTRACT_ACTIONS.SET_BOND_VALUES,
      value: {
        bond_months: Number(bondsNumber),
        bond_value: Number(rent),
      },
    })

    handleStepChange('PaydaySelect')
  }

  const bondOptions = getDepositMonthsOptions(rent)

  const handleBondsSelect = (option) => {
    setBondsNumber(option.id)
  }

  return (
    <div>
      <p className={commonClasses.contractSubtitle}>
        Escolha o numero de cauções que você quer receber de garantia. Você pode também não cobrar nenhuma
        garantia.
      </p>

      <div style={{ marginTop: 16 }}>
        <SelectBox selected={bondsNumber} options={bondOptions} onClick={handleBondsSelect} />
      </div>

      <div style={{ margin: '16px 0' }}>
        <ErrorComponent errors={errors} />
      </div>
      <div className='end-aligner'>
        <NoBackgroundButton title='Voltar' onClick={() => handleStepChange('NegotiatedConditions')} />
        <Button title='CONFIRMAR' onClick={handleSetInsurance} />
      </div>
    </div>
  )
}

export default NumberOfDeposits
